import React, { PropsWithChildren, Suspense } from 'react';

import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';

export type QueryErrorFallbackProps = {
  error: unknown;
  reset: () => void;
};

export type QueryAwaitProps = PropsWithChildren<{
  errorFallback: (
    props: QueryErrorFallbackProps,
  ) => React.ReactNode | Promise<React.ReactNode>;
  pendingFallback: (props: {}) => React.ReactNode | Promise<React.ReactNode>;
}>;

export const QueryAwait: React.FC<QueryAwaitProps> = ({
  children,
  errorFallback,
  pendingFallback,
}) => {
  const ErrorFallback = errorFallback;
  const PendingFallback = pendingFallback;

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          fallbackRender={({ error, resetErrorBoundary }) => (
            <ErrorFallback error={error} reset={resetErrorBoundary} />
          )}
          onReset={reset}
        >
          <Suspense fallback={<PendingFallback />}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};
